<template>
  <div class="pc-home">
    <div ref="topNav" class="top-nav" :class="{ 'is-scrolled': isScrolled }">
      <div class="nav-safe">
        <div class="nav-left">
          <img class="logo" src="@/assets/pc/logo.png" alt="准赞">
        </div>
        <div class="nav-right">
          <button type="button" class="nav-btn" @click="scrollToBlock2">
            <span class="btn-text">准赞APP下载</span>
            <span class="btn-icon">
              <img class="icon-img icon-purple" src="@/assets/pc/icon/icon_arrow_purple.png" alt="">
              <img class="icon-img icon-white" src="@/assets/pc/icon/icon_arrow_white.png" alt="">
            </span>
          </button>
          <button type="button" class="nav-btn" @click="scrollToBlock4">
            <span class="btn-text">产品展示</span>
            <span class="btn-icon">
              <img class="icon-img icon-purple" src="@/assets/pc/icon/icon_arrow_purple.png" alt="">
              <img class="icon-img icon-white" src="@/assets/pc/icon/icon_arrow_white.png" alt="">
            </span>
          </button>
        </div>
      </div>
    </div>
    <section class="block block-1">
      <div class="block-content">
        <img src="@/assets/pc/block_01_img.png" alt="">
        <div class="block-1-content">
          <p class="main_title"><span>平行世界 乐趣无限</span></p>
          <p class="main_desc">连接另一个自己，探索平行世界的可能</p>
        </div>
      </div>
      <div class="block-content download-content">
        <div ref="downloadActions" class="download-actions">
          <a class="download-item" href="https://apps.apple.com/cn/app/%E5%87%86%E8%B5%9E-%E9%81%87%E8%A7%81%E5%8F%A6%E4%B8%80%E4%B8%AA%E6%9C%89%E8%B6%A3%E7%9A%84%E4%BD%A0/id6769264855" target="_blank" rel="noopener">
            <img class="download-img" src="@/assets/pc/ios_btn.png" alt="">
            <div class="download-text">准赞APP苹果版</div>
          </a>
          <a class="download-item" href="https://www.zhunzan.cc/apk/zhunzan.apk" target="_blank" rel="noopener">
            <img class="download-img" src="@/assets/pc/android_btn.png" alt="">
            <div class="download-text">准赞APP安卓版</div>
          </a>
        </div>
        <p class="page-desc">准赞是基于AI大模型能力构建的数字分身平行世界社交网络，致力于为用户打造数字分身与真人的沉浸式社交体验，每个分身背后都有一个真实有趣的你。</p>
        <div class="contact-info">
          <span>商务合作:zhunzan001@126.com</span>
          <a href="https://www.zhunzan.cc/h5/#/pages/mine/service" target="_blank">用户协议</a>
          <a href="https://www.zhunzan.cc/h5/#/pages/mine/privacy" target="_blank">隐私协议</a>
          <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2026013591号-1</a>
        </div>
      </div>
    </section>
    <section class="block block-2">
      <div class="block-content block-flex">
        <div class="block-side left">
          <img class="block-img" src="@/assets/pc/block_02_img.png" alt="">
        </div>
        <div class="block-side right">
          <p class="main_title"><span>你眼前的 只是此刻</span></p>
          <p class="sub_desc">其实另一个你，正在真实发生</p>
          <div class="download-actions" style="margin-top: 40px;">
            <a class="download-item" href="https://apps.apple.com/cn/app/%E5%87%86%E8%B5%9E-%E9%81%87%E8%A7%81%E5%8F%A6%E4%B8%80%E4%B8%AA%E6%9C%89%E8%B6%A3%E7%9A%84%E4%BD%A0/id6769264855" target="_blank" rel="noopener">
              <img class="download-img" src="@/assets/pc/ios_btn.png" alt="">
              <div class="download-text">准赞APP苹果版</div>
            </a>
            <a class="download-item" href="https://www.zhunzan.cc/apk/zhunzan.apk" target="_blank" rel="noopener">
              <img class="download-img" src="@/assets/pc/android_btn.png" alt="">
              <div class="download-text">准赞APP安卓版</div>
            </a>
          </div>
        </div>
      </div>
    </section>
    <section class="block block-3">
      <div class="block-content block-flex">
        <div class="block-side right">
          <p class="main_title"><span>你还没出现 TA已经动心</span></p>
          <p class="sub_desc">期待与你真实相遇</p>
          <div class="download-actions" style="margin-top: 40px;">
            <a class="download-item" href="https://apps.apple.com/cn/app/%E5%87%86%E8%B5%9E-%E9%81%87%E8%A7%81%E5%8F%A6%E4%B8%80%E4%B8%AA%E6%9C%89%E8%B6%A3%E7%9A%84%E4%BD%A0/id6769264855" target="_blank" rel="noopener">
              <img class="download-img" src="@/assets/pc/ios_btn.png" alt="">
              <div class="download-text">准赞APP苹果版</div>
            </a>
            <a class="download-item" href="https://www.zhunzan.cc/apk/zhunzan.apk" target="_blank" rel="noopener">
              <img class="download-img" src="@/assets/pc/android_btn.png" alt="">
              <div class="download-text">准赞APP安卓版</div>
            </a>
          </div>
        </div>
        <div class="block-side left">
          <img class="block-img" src="@/assets/pc/block_03_img.png" alt="">
        </div>
      </div>
    </section>
    <section ref="block4" class="block block-4">
      <div class="block-content block-flex">
        <div class="block-side right">
          <p class="main_title"><span>虚拟互动 真实连接</span></p>
          <p class="sub_desc">先遇见分身，再连接真实<br/>每次互动都是通往TA的钥匙</p>
          <div class="download-actions" style="margin-top: 40px;">
            <a class="download-item" href="https://apps.apple.com/cn/app/%E5%87%86%E8%B5%9E-%E9%81%87%E8%A7%81%E5%8F%A6%E4%B8%80%E4%B8%AA%E6%9C%89%E8%B6%A3%E7%9A%84%E4%BD%A0/id6769264855" target="_blank" rel="noopener">
              <img class="download-img" src="@/assets/pc/ios_btn.png" alt="">
              <div class="download-text">准赞APP苹果版</div>
            </a>
            <a class="download-item" href="https://www.zhunzan.cc/apk/zhunzan.apk" target="_blank" rel="noopener">
              <img class="download-img" src="@/assets/pc/android_btn.png" alt="">
              <div class="download-text">准赞APP安卓版</div>
            </a>
          </div>
        </div>
        <div class="block-side left">
          <img class="block-img" src="@/assets/pc/block_04_img.png" alt="">
        </div>
      </div>
    </section>
  </div>
</template>

<script>

const NAV_SCROLL_THRESHOLD = 80

export default {
  name: 'PcHome',
  data() {
    return {
      isScrolled: false,
    }
  },
  mounted() {
    this.updateNavState()
    window.addEventListener('scroll', this.updateNavState, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateNavState)
  },
  methods: {
    updateNavState() {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0
      this.isScrolled = y > NAV_SCROLL_THRESHOLD
    },
    scrollToBlock2() {
      const el = this.$refs.downloadActions
      if (!el) return
      const top = el.getBoundingClientRect().top + (window.pageYOffset || 0) - NAV_SCROLL_THRESHOLD - 300
      window.scrollTo({ top, behavior: 'smooth' })
    },
    scrollToBlock4() {
      const el = this.$refs.block4
      if (!el) return
      const top = el.getBoundingClientRect().top + (window.pageYOffset || 0) - 80
      window.scrollTo({ top, behavior: 'smooth' })
    },
  },
}
</script>

<style scoped lang="scss">
$purple: #871bdb;
$white: #ffffff;
$safe-width: 1260px;
$btn-gradient: linear-gradient(230deg, #fec212 0%, #e34bc1 30.54%, #871bdb 100%);
$title-gradient: linear-gradient(270deg, #fec212 0%, #e34bc1 31%, #871bdb 100%);

.pc-home {
  min-height: 100vh;
  background: #fff;

  .top-nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    height: 80px;
    background-color: transparent;
    transition: background-color 120ms linear;

    &.is-scrolled {
      background-color: $white;
    }

    .nav-safe {
      max-width: $safe-width;
      height: 100%;
      padding: 0 20px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
    }

    .logo {
      display: block;
      height: 32px;
    }

    .nav-right {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .nav-btn {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      height: 44px;
      padding: 0 20px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 24px;
      border: 1px solid $white;
      font-weight: 500;
      font-size: 16px;
      color: $purple;
      box-sizing: border-box;
      user-select: none;

      &:hover {
        background: $btn-gradient;
        color: $white;
        border-color: transparent;

        .icon-white {
          opacity: 1;
        }

        .icon-purple {
          opacity: 0;
        }
      }
    }

    &.is-scrolled {
      .nav-btn {
        border-color: $purple;

        &:hover {
          border-color: transparent;
        }
      }
    }

    .btn-icon {
      position: relative;
      width: 16px;
      height: 16px;
      flex: 0 0 16px;
    }

    .icon-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 16px;
      height: 16px;
    }

    .icon-white {
      opacity: 0;
    }
  }

  .block {
    width: 100%;
    height: 1080px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: auto;
    box-sizing: border-box;

    &.block-1 {
      background-image: url('~@/assets/pc/bg_01.png');
      padding-top: 119px;
    }

    &.block-2 {
      background-image: url('~@/assets/pc/bg_02.png');
    }

    &.block-3 {
      background-image: url('~@/assets/pc/bg_03.png');
    }

    &.block-4 {
      background-image: url('~@/assets/pc/bg_04.png');
    }
  }

  .block-content {
    position: relative;
    max-width: $safe-width;
    margin: 0 auto;
    text-align: center;

    .block-1-content {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
    }
  }

  .block-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    text-align: initial;
  }

  .block-side {
    display: flex;
    align-items: center;

    &.left {
      justify-content: flex-start;
    }

    &.right {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .block-img {
    display: block;
    width: 100%;
  }

  .download-content {
    margin-top: 30px;
  }

  .download-actions {
    display: flex;
    justify-content: center;
    gap: 24px;
  }

  .download-item {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }

  .download-text {
    font-size: 12px;
    color: #989898;
    line-height: 17px;
  }

  .page-desc {
    width: 423px;
    margin: 58px auto 0;
    font-size: 12px;
    color: #212121;
    line-height: 17px;
    text-align: center;
  }

  .contact-info {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 12px;
    color: #989898;
    line-height: 17px;

    a {
      color: inherit;
    }
  }

  .main_title {
    font-weight: 600;
    font-size: 52px;
    line-height: 73px;
    text-align: center;
    font-style: normal;
    text-transform: none;

    > span {
      background: $title-gradient;
      -webkit-background-clip: text;
      background-clip: text;
      white-space: nowrap;
      color: transparent;
      -webkit-text-fill-color: transparent;
    }
  }

  .main_desc {
    font-weight: 400;
    font-size: 26px;
    color: $purple;
    line-height: 36px;
    letter-spacing: 5px;
    text-align: center;
  }
  .sub_desc {
    font-size: 26px;
    color: #212121;
    line-height: 46px;
    letter-spacing: 5px;
    margin-top: 10px;
  }
}
</style>
